import { useState } from 'react';
import { Div, Gutter } from '@gaiads/telia-react-component-library';
import { Switch, Route, useRouteMatch, Redirect } from 'react-router-dom';
import ImportUsersStepper from './ImportUsersStepper/ImportUsersStepper';
import UploadTemplate from './UploadTemplate/UploadTemplate';
import ReviewAndSave from './ReviewAndSave/ReviewAndSave';
import { IMPORT_USERS_FLOW_CONSTANTS } from '../../../utils/constants';
import { User } from '../../../types';
import Summary from './Summary/Summary';

export default function ImportUsers() {
  const { path } = useRouteMatch();

  const [usersToImport, setUsersToImport] = useState<User[]>([]);

  return (
    <Div style={{ paddingBottom: '128px' }}>
      <div>
        <Gutter size="xlg" />
        <ImportUsersStepper />
        <Gutter size="xlg" />
      </div>

      <Switch>
        <Route path={`${path}/${IMPORT_USERS_FLOW_CONSTANTS.uploadTemplate}`}>
          <UploadTemplate setUsersToImport={setUsersToImport} />
        </Route>
        <Route path={`${path}/${IMPORT_USERS_FLOW_CONSTANTS.reviewAndSave}`}>
          <ReviewAndSave usersToImport={usersToImport} setUsersToImport={setUsersToImport} />
        </Route>
        <Route path={`${path}/${IMPORT_USERS_FLOW_CONSTANTS.summary}`}>
          <Summary usersToImport={usersToImport} />
        </Route>
        <Redirect to={`${path}/${IMPORT_USERS_FLOW_CONSTANTS.uploadTemplate}`} />
      </Switch>
    </Div>
  );
}
